module.exports = __webpack_public_path__ + "static/img/img7.43238a71.png";